/**
 * Base Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var Backbone = require('backbone');

    /**
     * @class
     * @name BaseCollection
     * @augments Backbone.Collection
     */
    module.exports = Backbone.Collection.extend(/** @lends BaseModel.prototype */ {

        /**
         * There is an issue in Backbone in that there is no moment in time currently when collection inheritor
         * can access parsed and set models that were passed to constructor.
         *
         * When you create some collection Backbone calls `initialize` method and only after that
         * it calls `reset` method that creates set of models inside. So if you want to do some
         * stuff with models you can't do it in `initialize`. Basically, you could use 'reset'
         * event for your purposes, but it doesn't trigger unless constructor is called with
         * {silent: false} option explicitly, which is not what we can control inside our class.
         *
         * If you in dire need to work with models after set you may need to override constructor.
         *
         * https://github.com/jashkenas/backbone/issues/814
         */
        constructor: function() {
            Backbone.Collection.apply(this, arguments);
            this.subscribe.apply(this, arguments);
        },

        /**
         * Init all listeners in subscribe method for better inheritance
         */
        subscribe: _.noop,

        fetch: function(options) { // eslint-disable-line
            this.trigger('fetch', this);
            return Backbone.Collection.prototype.fetch.apply(this, arguments);
        },

        close: function() {
            this.stopListening();
            this.invoke('close');
        }
    });
});
